module.exports = __webpack_public_path__ + "7d0c102b485aad5b0d933f7951aa3da0.png";